import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import FormSectionCard from './FormSectionCard';
import TextField from '../../text-field';
import { FormState } from '../../../hooks/useFormState.types';
import { EnergyConsultationFormModel } from '../types';
import { useTranslation } from '../../../hooks/useTranslation';

interface Props {
  form: FormState<EnergyConsultationFormModel>;
}

const AdditionalCommentsSection: React.FC<Props> = ({ form }) => {
  const { t } = useTranslation();

  return (
    <FormSectionCard title={t('ADDITIONAL_COMMENTS')}>
      <Grid container spacing={2}>
        <TextField
          placeholder={t('ADDITIONAL_COMMENTS_PLACEHOLDER')}
          label=""
          multiline
          rows={4}
          rowsMax={4}
          InputLabelProps={{
            shrink: true,
            style: {
              top: '-14px',
            },
            className: 'otherTopicLabelPropClassName',
          }}
          inputProps={{ maxLength: 500 }}
          css={{
            width: '100%',
          }}
          {...form.props('comments')}
        />
        <Typography>
          {t('COMMENT_LENGTH_INDICATOR', {
            COMMENT_LENGTH: form.values?.comments?.length?.toString() || '0',
          })}
        </Typography>
      </Grid>
    </FormSectionCard>
  );
};

export default AdditionalCommentsSection;
